import { teamMembers } from "@/mocks/content";

export default function TeamSection() {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-site mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] text-accent-700 mb-3">
            OUR TEAM
          </p>
          <h3 className="text-2xl md:text-3xl font-semibold text-foreground-950 font-heading">
            核心团队
          </h3>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            一群相信「细节值得长期耐心」的人，共同支撑起白峰美羽的产品与文化。
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {teamMembers.map((member) => (
            <div
              key={member.id}
              className="bg-background-50 border border-background-200 rounded-lg overflow-hidden"
            >
              <div className="w-full aspect-square overflow-hidden bg-background-200">
                <img
                  src={member.photo}
                  alt={member.name}
                  title={`${member.name} - 白峰美羽`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4">
                <h4 className="text-sm md:text-base font-medium text-foreground-950">
                  {member.name}
                </h4>
                <p className="mt-0.5 text-xs text-accent-700">{member.role}</p>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}